"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var FinanceDepositList_1 = require("./component/FinanceDepositList");
var PFinanceDepositsList = /** @class */ (function (_super) {
    __extends(PFinanceDepositsList, _super);
    function PFinanceDepositsList(props) {
        return _super.call(this, props) || this;
    }
    PFinanceDepositsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.brandsData.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AD = this.props.depositTypesData.Subscribe("*", function (id, data) {
            _this.setState({ avail_deposit_types: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize,
                all_deposit_types: data.all_deposit_types,
                deposit_types_list: data.deposit_types_list
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_deposit_types: [],
            deposit_types_list: this.props.state.getDepositTypesList(),
            all_deposit_types: this.props.state.getIsAllDepositTypes()
        }, function () {
            _this.props.brandsData.LoadData();
            _this.props.depositTypesData.LoadData();
        });
    };
    PFinanceDepositsList.prototype.componentWillUnmount = function () {
        this.props.brandsData.UnSubscribe(this.SID_AB);
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.depositTypesData.UnSubscribe(this.SID_AD);
    };
    PFinanceDepositsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PFinanceDepositsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PFinanceDepositsList.prototype.onDepositTypeFilterChanged = function (allDepostTypes, DepositTypeCode, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllDepositTypes(allDepostTypes, true);
        }
        if (Action === "add") {
            this.props.state.addDepositType(DepositTypeCode, true);
        }
        if (Action === "remove") {
            this.props.state.delDepositType(DepositTypeCode, true);
        }
    };
    PFinanceDepositsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(FinanceDepositList_1.default, { data: this.props.data, state: this.props.state, onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onDepositTypeFilterChanged: this.onDepositTypeFilterChanged.bind(this), allDepositTypes: this.state.all_deposit_types, depositTypesList: this.state.deposit_types_list, availDepositTypes: this.state.avail_deposit_types }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PFinanceDepositsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PFinanceDepositsList.getPageDescription = function (state) {
        return {
            icon: "money-check-alt",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_finance_deposits_list + "-id",
            itemTitle: "Депозиты",
            route: routes_1.routes.page_finance_deposits_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PFinanceDepositsList;
}(React.Component));
exports.default = PFinanceDepositsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_deposits_list/ui/PFinanceDepositsList.tsx
// module id = 1988
// module chunks = 0